import View from "./view";
import Presenter from "./presenter";
import { ConnectComponent2 } from "util";

export default ConnectComponent2(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/support/sidebar/index.js